import { Component, Input, OnInit } from '@angular/core';
import { InformationMessages } from '../../../../shared/models/component-messages/information-messages';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent implements OnInit {

  @Input() fileName: string;
  @Input() result: string;
  @Input() fileNameOriginal: string;
  @Input() size: number;
  @Input() tsize: number;
  public informationMessages = new InformationMessages();

  constructor() {
  }

  public async ngOnInit() {
  }
}
